<template>
    <div class="login-page-wrapper" :class="{'bodyfont-unauth': !user}">
        <div class="over-lay"></div>
        <div class="container">
            <div class="row aboutrow">
                <div class="col-md-12">
                    <div class="main-content">
                        <h2 class="heading" v-bind:style="{ color: getCorpHeaderColor } ">TONE Press Room</h2>
                    </div>
                </div>
                <div class="col-sm-8 col-sm-offset-2" style="text-align:left">
                    <h3 v-bind:style="{ backgroundColor: getCorpHeaderColor}">Overview</h3>
                    <div class="row">
                        <div class="col-sm-8">
                            <p style="text-align:left">
                                TONE Networks, the first brand of ChartOne Media, is a subscription- based, short form video and social network. The platform features bite-sized videos from highly sought after, credentialed experts covering a range of topics. Designed to effortlessly integrate into the lives of busy women, TONE Networks offers personalized content with actionable tips and access to both expert coaching and peer to peer advice. TONE Networks reinforces the growing women helping women movement by providing a supportive online community complete with live chats and events with its experts, providing a vibrant, supportive community for women.
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <div class="addressholder" :style="{borderWidth: '2px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}">
                                <strong>Kara Brown</strong> <br>
                                kara@smithbrownmarketing.com <br>
<!--                                Cell: 240-477-9873-->
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <h3 v-bind:style="{ backgroundColor: getCorpHeaderColor}">Press Releases</h3>
                    <div class="presscontainer" v-if="pressSection">

                        <div class="pressentry" v-for="press in pressSection">
                            <h5>
                                <a :href="press.pdfUrl" target="_blank" rel="opener" v-bind:style="{ color: getCorpHeaderColor}">{{press.topicSubHead}}</a>
                                <small>
                                    {{press.topicSubHeadDateFmt}}
                                </small>
                            </h5>
                            <p>
                              {{press.topicSubHeadContents}}
                            </p>
                        </div>

                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href="https://s3.amazonaws.com/assets.tonenetworks.com/images/30-Day+Free+Trial-2018-05-29.pdf" target="_blank">Expands with New Experts, More Videos and a 30-Day Free Trial</a>-->
                                <!--<small>-->
                                    <!--05/29/2018-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--Discover resources from nationally acclaimed experts offering real-world “How To” advice for women in-->
                                <!--all areas of Work, Life, Mind, Body and Money-->
                            <!--</p>-->
                        <!--</div>-->

                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href="https://s3.amazonaws.com/assets.tonenetworks.com/images/MentalHealthAwareness-2018-05-09.pdf" target="_blank">Mental Health Awareness Month</a>-->
                                <!--<small>-->
                                    <!--05/09/2018-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--Tone Networks Expert Dr. Tracy Alloway Offers Tips to Boost Mental Fitness for-->
                                <!--Mental Health Awareness Month-->
                            <!--</p>-->
                        <!--</div>-->

                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href="https://s3.amazonaws.com/assets.tonenetworks.com/images/mothersdayrelease-2018-05-01.pdf" target="_blank">Mother's Day</a>-->
                                <!--<small>-->
                                    <!--05/01/2018-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--Give Mom the Ultimate Life Hack this Mother's Day-->
                            <!--</p>-->
                        <!--</div>-->

                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href="https://s3.amazonaws.com/assets.tonenetworks.com/images/WomenHelpingWomenMovement-2017-10-24.pdf" target="_blank">Reinforces Growing Women Helping Women Movement</a>-->
                                <!--<small>-->
                                    <!--10/24/2017-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--Tone Networks for Time-Starved Women Launches; Reinforces Growing-->
                                <!--Women Helping Women Movement-->
                            <!--</p>-->
                        <!--</div>-->
                    </div>
                    <div class="clearfix"></div>

                    <h3 v-bind:style="{ backgroundColor: getCorpHeaderColor}">In the News</h3>
                    <div class="presscontainer" v-if="newsSection">
                        <div class="pressentry" v-for="news in newsSection">
                            <h5>
                                <a :href="news.pdfUrl" target="_blank" rel="opener" v-bind:style="{ color: getCorpHeaderColor}">{{news.topicSubHead}}</a>
                                <small>
                                    {{news.topicSubHeadDateFmt}}
                                </small>
                            </h5>
                            <p>
                                {{news.topicSubHeadContents}}
                            </p>
                        </div>
                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href="https://medium.com/authority-magazine/women-of-the-c-suite-recognition-encouragement-and-respect-with-gemma-toner-ceo-of-tone-42aadb4b0397?sk=b4534213d9d136bdc69c3a242d2a6ece" target="_blank">Medium</a>-->
                                <!--<small>-->
                                    <!--09/07/18-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--Longtime media exec and TONE Networks/ChartOne founder Gemma Toner shares her tips for women in the business world and what she wishes she knew when she was starting out.-->
                            <!--</p>-->
                        <!--</div>-->
                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href="https://www.mscareergirl.com/personal-brand-image/" target="_blank">Ms. Career Girl</a>-->
                                <!--<small>-->
                                    <!--08/29/18-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--Having a defined brand and personal image helps us forge ahead confidently in our careers.-->
                                <!--CEO and brand strategist Robin Roffer lays out the steps to creating your own destiny.-->
                            <!--</p>-->
                        <!--</div>-->
                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href=" https://www.reviewofoptometry.com/wo/growth-strategies/quick-tips/article/living-your-fearless-career/?utm_medium=email&utm_source=wowednesday" target="_blank">Women in Optometry</a>-->
                                <!--<small>-->
                                    <!--08/22/18-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--Fearless career coach and Tone Expert Robin Fisher Roffer offers six tips on how to be fearless in your career.-->
                            <!--</p>-->
                        <!--</div>-->
                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href="http://www.mariasspace.com/2018/08/youre-empty-nester-now-what.html" target="_blank">Maria's Space</a>-->
                                <!--<small>-->
                                    <!--08/22/18-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--Tone Expert Robin Roffer offers advice to parents on how to deal with their "empty nest" when the children move on.-->
                            <!--</p>-->
                        <!--</div>-->
                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href="http://www.yellowbeadsandme.com/2018/08/guest-post-youre-empty-nester-now-what.html" target="_blank">Yellow Beads and Me</a>-->
                                <!--<small>-->
                                    <!--08/21/18-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--Tone Expert Robin Roffer offers advice to parents on how to deal with their "empty nest" when the children move on.-->
                            <!--</p>-->
                        <!--</div>-->
                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href="https://www.mscareergirl.com/managing-gossip-and-bullying-in-the-office/" target="_blank">Ms. Career Girl</a>-->
                                <!--<small>-->
                                    <!--08/08/2018-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--TONE expert Val Grubb shares insights on managing gossip and bullying in the office.-->
                            <!--</p>-->
                        <!--</div>-->
                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href="https://bestlifeonline.com/cheating-wife/" target="_blank">Best Life</a>-->
                                <!--<small>-->
                                    <!--08/03/2018-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--Dr. Ramani Durvasula offers insights into the tell tale signs of spousal infidelity.-->
                            <!--</p>-->
                        <!--</div>-->
                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href="https://www.glam.com/choice-overload-problematic-in-online-dating/" target="_blank">Glam</a>-->
                                <!--<small>-->
                                    <!--08/02/2018-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--Dr. Ramani Durvasula examines the problems with dating apps.-->
                            <!--</p>-->
                        <!--</div>-->
                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href="https://bestlifeonline.com/signs-of-cheating/" target="_blank">Best Life</a>-->
                                <!--<small>-->
                                    <!--07/26/2018-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--Dr. Ramani Durvasula offers insights into the tell tale signs of spousal infidelity.-->
                            <!--</p>-->
                        <!--</div>-->
                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href="https://www.glam.com/everything-to-know-about-micro-cheating/" target="_blank">Glam</a>-->
                                <!--<small>-->
                                    <!--07/20/2018-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--TONE Expert Dr. Ramani Durvasula explains the new concept of microcheating, how to spot it, and why it may not be intentional.-->
                            <!--</p>-->
                        <!--</div>-->
                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href="https://www.thisisinsider.com/should-we-go-on-a-break-2018-7" target="_blank">Insider</a>-->
                                <!--<small>-->
                                    <!--07/17/2018-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--TONE expert Dr. Ramani explains the importance of taking some time off from your significant other-->
                            <!--</p>-->
                        <!--</div>-->
                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href="https://laopinion.com/2018/06/30/tips-para-tener-una-mejor-relacion-consigo-mismo/" target="_blank">La Opinion</a>-->
                                <!--<small>-->
                                    <!--06/30/2018-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--Tone expert Dr. Ramani Durvasala explains how to Have a Better Relationship with Yourself.-->
                            <!--</p>-->
                        <!--</div>-->
                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href="http://www.cynopsis.com/060118-tone-networks-gemma-toner-shares-tips-for-informational-short-form-content/" target="_blank">Cynopsis</a>-->
                                <!--<small>-->
                                    <!--06/01/2018-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--TONE CEO and Founder Gemma Toner discusses The Art of Informational Short Form Content.-->
                            <!--</p>-->
                        <!--</div>-->
                        <!--<div class="pressentry">-->
                            <!--<h5>-->
                                <!--<a href="http://myemail.constantcontact.com/Honoring-Caribbean-American-Heritage-Month.html?soid=1113611784510&aid=WeJi1UZQIgw" target="_blank">National Association for Multi-Ethnicity in Communications (NAMIC)</a>-->
                                <!--<small>-->
                                    <!--05/29/2018-->
                                <!--</small>-->
                            <!--</h5>-->
                            <!--<p>-->
                                <!--TONE Networks expands with New Experts, New Videos and a 30 day Free Trial.-->
                            <!--</p>-->
                        <!--</div>-->
                    </div>
                    <div class="clearfix"></div>


                    <h3 v-bind:style="{ backgroundColor: getCorpHeaderColor}">Media Access</h3>
                    <div class="row mediasignup">
                        <div class="col-sm-6">
                            <h2 v-bind:style="{ color: getCorpHeaderColor}">
                                Sign Up For Press Release.
                            </h2>
                        </div>
                        <div class="col-sm-6">
                            <form id="footer_form" v-on:submit.prevent="onSubmitEmail">
                            <div class="input-group input-md float-right" >
                                <input v-model="subscriptionForm.email"  type="email" class="form-control" placeholder="email"  title="invalid email address"  :style="{borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" required>
                                <span   class="input-group-addon cursor"><button type="submit" :style="{backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}"><i class="fa fa-arrow-right"></i></button></span>

                            </div>
                        </form>
                        </div>
                    </div>
                </div>

                <!--<div class="col-sm-12">
                    <h4 class="welcomemessage">
                        We are so happy to see you.
                    </h4>
                    <h2 class="welcomemessage">
                        <b>Welcome to Tone Networks</b><br>
                        <small>Set the Tone of your Life</small>
                    </h2>
                </div>-->
            </div>
            <div class="clearfix"></div>
            <!--<div class="slider responsive-slick-imagelist">
                <div>
                    <div class="slide-player">
                        <img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Gemma-Toner-Founder-&-CEO.png"/>
                        <h4 class="text-center">Gemma Toner<br /><small>Founder & CEO</small></h4>
                    </div>
                </div>
                <div>
                    <div class="slide-player">
                        <img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Mike-Sorrentino-Producer.png"/>
                        <h4 class="text-center">Mike Sorrentino<br /><small>Producer</small></h4>
                    </div>
                </div>
                <div>
                    <div class="slide-player">
                        <img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Elli-Zaverdas-Marketing-&-Sales-Director.png"/>
                        <h4 class="text-center">Elli Zaverdas<br /><small>Marketing & Sales Director</small></h4>
                    </div>
                </div>
                <div>
                    <div class="slide-player">
                        <img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Paula-Doyle-VP-of-Development-and-Community.png"/>
                        <h4 class="text-center">Paula Doyle<br /><small>VP of Development and Community</small></h4>
                    </div>
                </div>
                <div>
                    <div class="slide-player">
                        <img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Jonathan-Disegi-Brand-Consultant.png"/>
                        <h4 class="text-center">Jonathan Disegi<br /><small>Brand Consultant</small></h4>
                    </div>
                </div>
                <div>
                    <div class="slide-player">
                        <img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Pippa-Schwarzkopf-Editor.png"/>
                        <h4 class="text-center">Pippa Schwarzkopf<br /><small>Editor</small></h4>
                    </div>
                </div>
                <div>
                    <div class="slide-player">
                        <img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Dominique-Rollins-Editor.png"/>
                        <h4 class="text-center">Dominique<br /><small>Editor</small></h4>
                    </div>
                </div>
                <div>
                    <div class="slide-player">
                        <img src="https://s3.amazonaws.com/tone-assets-prod/images/team/Shiloh-Accuosti-Marketing-Assistant.png"/>
                        <h4 class="text-center">Shiloh Accuosti<br /><small>Marketing Assistant</small></h4>
                    </div>
                </div>
            </div>-->
        </div>
    </div>
</template>

<script>
    import { input, spinner, alert } from 'vue-strap'
    import { mapGetters } from 'vuex'
    import slick from 'slick-carousel'
    import $ from 'jquery'

    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'alert': alert
        },
        name: 'login',
        metaInfo () {
            return {
                title: 'TONE | Press Releases',
                meta: [
                    {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {property: 'og:title', content: 'TONE | Press Releases'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'twitter:title', content: 'TONE | Press Releases'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                success: false,
                successMsg: '',
                pressSection: null,
                newsSection: null,
                subscriptionForm: {
                    userId: null,
                    email: '',
                    name: '',
                    comments: 'Newsletter Subscription (PRESS)',
                    rating: 0,
                    newsLetterEmail: '1',
                    promotionalEmail: '0',
                    representativeCall: '0'
                },
                spinner: false
            }
        },
        computed: {
            ...mapGetters([
                'error', 'getPressReleaseData', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'
            ])
        },
        methods: {
            onSubmitEmail () {
                var self = this
                this.subscriptionForm.comments = 'Newsletter Subscription'
                this.subscriptionForm.newsLetterEmail = '1'
                let displayMsg = 'Successfully subscribed to newsletter'
                this.subscriptionForm.email = this.subscriptionForm.email.toLowerCase()
                if (self.verifyEmail(this.subscriptionForm.email)) {
                    this.$store.dispatch('SENDFEEDBACKFORM', this.subscriptionForm).then(() => {
                        window.logEvents('Newsletter Subscription (Press)', 'Subscribed', `Press Subscription Email: ${this.subscriptionForm.email}`)
                        // this.successMsg = 'Successfully Subscribed'
                        self.$swal({
                            title: displayMsg,
                            text: '',
                            type: 'success',
                            timer: 3000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                        setTimeout(() => {
                            this.success = false
                            this.subscriptionForm.email = ''
                            this.subscriptionForm.promotionalEmail = '0'
                            this.subscriptionForm.userId = null
                            this.subscriptionForm.email = ''
                            this.subscriptionForm.name = ''
                            this.subscriptionForm.comments = 'Newsletter Subscription (PRESS)'
                            this.subscriptionForm.rating = 0
                            this.subscriptionForm.newsLetterEmail = '1'
                            this.subscriptionForm.promotionalEmail = '0'
                            this.subscriptionForm.representativeCall = '0'
                        }, 2000)
                    })
                }
            },
            verifyEmail (email) {
                if (email.length > 0) {
                    let re = /\S+@\S+\.\S+/
                    if (!re.test(email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            spinnerToggle () {
                this.spinner = !this.spinner
            },
            onSubmit () {
                if (this.contactForm.emailAddress && this.contactForm.phoneNumber) {
                    this.spinnerToggle()
                    this.$store.dispatch('SENDCONTACTUSFORM', this.contactForm).then(() => {
                        this.success = true
                        this.successMsg = 'Your message has been sent, we will get back to you shortly!'
                        this.spinnerToggle()
                    })
                }
            },
            setCarousal () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-imagelist')
                $slick.each(function () {
                    $slick.slick({
                        dots: false,
                        infinite: false,
                        speed: 300,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                infinite: true,
                                dots: false
                            }
                        }, {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    })
                })
            }
        },
        mounted: function () {
            let self = this
            self.$store.dispatch('GETPRESSRELEASES').then(() => {
                if (self.getPressReleaseData) {
                    let pressReleases = this.getPressReleaseData.filter(x => {
                        return x.contentOrder === 2
                    })
                    self.pressSection = pressReleases
                    let newsReleases = this.getPressReleaseData.filter(x => {
                        return x.contentOrder === 3
                    })
                    self.newsSection = newsReleases
                }
            })
            this.setCarousal()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .addressholder {
        word-wrap: break-word;
    }
    h2.heading {
        color: #f0617d;
        text-transform: capitalize;
        margin: 47px 0 35px 0;
        letter-spacing: 0.5px;
        font-family: sans-serif;
        font-size: 30px;
    }
    .aboutlogoholder {
        min-height: 300px;
        line-height: 300px;
    }

    .mtop30 {
        margin-top: 30px;
    }

    .row.aboutrow p {
        font-size: 17px;
        text-align: left;
        line-height: 1.5;
        letter-spacing: 2px;
    }
    h3 {
        background: #f0617d;
        letter-spacing: 2px;
        font-size: 19px;
        line-height: 1.5;
        margin: 30px 0 20px;
        padding: 5px 10px;
        color: #Fff;
        font-weight: 900;
    }
    h4 {
        color: #f0617d;
        letter-spacing: 4px;
        font-size: 22px;
        text-align: left;
        line-height: 1.5;
    }
    h4.welcomemessage {
        text-align: center;
        margin: 50px 0 0;
        color: inherit;
        color: #f0617d;
    }

    h2.welcomemessage {
        letter-spacing: 8px;
        margin: 20px 0 60px;
        text-transform: uppercase;
    }
    .slide-player img {
        max-width: 100%;
    }
    .addressholder {
        text-align: left;
        background: #ddd;
        font-size: 12px;
        padding: 10px;
        border: 3px solid #f0617d;
    }

    .pressentry h5 {
        font-size: 17px;
        font-weight: 700;
    }

    .pressentry h5 small {
        display: block;
        margin: 10px 0 20px;
    }

    .pressentry {
        border-bottom: 3px solid #ccc;
        margin: 20px 0;
    }

    .pressentry:last-of-type {
        margin: 0;
        border-bottom: none transparent;
    }

    .pressentry h5 a {
        color: #f0617d;
    }
    .mediasignup h2 {
        color: #f0617d;
        font-size: 21px;
        font-weight: 700;
        margin: 8px 0;
    }

    .mediasignup {
        padding-bottom: 50px;
    }

    .mediasignup span.input-group-addon.cursor.input-group-addon:last-child {
        padding: 0;
        /*background: #f0617d;*/
        /*border-color: #f0617d;*/
    }

    .mediasignup .input-group.input-md.float-right input {
        height: 40px;
        border: 1px solid #f0617d;
    }

    .mediasignup span.input-group-addon.cursor.input-group-addon:last-child button {
        border: 0 none transparent;
        padding: 6px;
        font-size: 24px;
        color: #ffffff;
        background: transparent;
    }
    @media(max-width:480px){
        body h4 {
            font-size: 18px !important;
        }

        h3 {
            font-size: 24px !important;
            line-height: 1.1 !important;
        }

        h2.welcomemessage {
            letter-spacing: 3px !important;
        }
    }
</style>



// WEBPACK FOOTER //
// PressRelease.vue?08864aa1